import { Button } from '@mui/material'
import React from 'react'

const ResetButton = ({ label, onClick }) => {
    return (
        <Button
            variant="outlined"
            sx={{
                width: '90px',
                height: '35px',
                marginRight: '8px',
                borderRadius: '5px',
                borderColor: '#5C3685',
                color: '#5C3685',
                textTransform: 'capitalize',
                fontFamily: 'Times New Roman',
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '20.7px'
            }}
            onClick={onClick}
        >
            {label}
        </Button>
    )
}

export default ResetButton